import api from './utils/api';

class EmailsService {
  async sendEmail(email) {
    const result = await api.post('/send-email', { email });

    return result.data;
  }

  async verifEmail(email, code) {
    const result = await api.post('/verif-email', { email, code });

    return result.data;
  }
}

export default new EmailsService();
